<template>
  <div class="mx-0 px-0">
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="container-xl">
      <div class="text-container">
        <div class="title-area">
          <div class="d-flex">
            <div class="pe-4">
              <div class="survey-type-badge btn-primary">
                <fa-icon icon="clipboard-list" class="survey-icon" />
              </div>
            </div>
            <h1 class="h2 d-flex align-items-center">
              {{ texts[1] }}
            </h1>
          </div>
        </div>
        <div v-if="step === 0" class="card border-0">
          <div class="card-body">
            <div>
              <SelectLanguage
                enabled-for="language_enabled_checklist"
                :defaultlanguage="language"
                @languagechange="setlanguage"
              />
            </div>
            <p>{{ texts[2] }}</p>
            <p>{{ texts[3] }}</p>
            <p>{{ texts[4] }}</p>
          </div>
        </div>
        <div v-if="step > 0 && step <= questions.length" class="card border-0">
          <div class="card-body">
            <h3 class="my-4 py-4">
              <span> {{ questions[step - 1].question_number }}. </span>
              {{ questions[step - 1].question_text }}
            </h3>
            <div class="row">
              <div
                class="btn-group btn-group-horizontal btn-group-toggle col text-center"
                role="group"
              >
                <label
                  v-for="index in options.length"
                  :id="index"
                  :key="index"
                  class="btn btn-questionnaire btn-questionnaire-horizontal btn-iphone text-center py-4"
                  :class="
                    (answers[step] != null && answers[step] === index) ||
                    currentoption === index
                      ? 'btn-primary'
                      : 'btn-outline-primary'
                  "
                  @click.prevent="handleAnswer(step, index)"
                >
                  <span
                    v-if="answers[step] && answers[step] === index"
                    class="mr-2"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 512 512"
                      focusable="false"
                      class="white fa-icon"
                    >
                      <path
                        d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0l112.1 112.1 240.1-240.1c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z"
                      />
                    </svg>
                  </span>
                  <input type="radio" class="text-center" />{{
                    options[index - 1]
                  }}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div v-if="step > questions.length" class="card border-0">
          <div class="card-body">
            <h3 class="my-4 py-4">
              {{ texts[5] ? texts[5] : "Result:" }} {{ result }}
            </h3>
            <div class="row">
              <div class="d-xs-none col-md-1" />
              <div class="thermometer ml-2 mr-0 text-center">
                <div
                  class="indicator"
                  style="position: relative"
                  :style="{ top: indicatortop + 'px' }"
                >
                  {{ result }}
                </div>
              </div>
              <div class="col-6 mr-2 pl-0">
                <div style="top: 0px; height: 110px">
                  {{
                    texts[6]
                      ? texts[6]
                      : "developable to an extremely large extent"
                  }}
                </div>
                <div style="top: 110px; height: 110px">
                  {{
                    texts[7] ? texts[7] : "developable to a fairly large extent"
                  }}
                </div>
                <div style="top: 230px; height: 120px">
                  {{ texts[15] ? texts[15] : "developable to some extent" }}
                </div>
                <div style="top: 355px">
                  {{ texts[8] ? texts[8] : "not at all developable" }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card border-0">
          <div class="card-body">
            <div class="row mb-4 pb-4">
              <div class="col-12 mt-5">
                <router-link v-if="step === 0" to="/create" class="float-left">
                  <button class="btn btn-secondary">
                    &lt;<span>&nbsp;{{ texts[9] ? texts[9] : "Back" }}</span>
                  </button>
                </router-link>
                <button
                  v-if="step > 0"
                  class="btn btn-secondary float-left"
                  @click="prevstep"
                >
                  &lt;<span>&nbsp;{{ texts[9] ? texts[9] : "Back" }}</span>
                </button>
                <button
                  v-if="step === 0"
                  class="btn btn-primary float-end"
                  @click="nextstep"
                >
                  <span>{{ texts[10] ? texts[10] : "Next" }}&nbsp;</span>&gt;
                </button>
                <button
                  v-if="step === 7"
                  class="btn btn-primary float-end"
                  @click="startover"
                >
                  <span>{{ texts[11] ? texts[11] : "Start over" }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { useStore } from "vuex";
import Navbar from "./Navbar.vue";
import Breadcrumb from "./Breadcrumb.vue";
import SelectLanguage from "./SelectLanguage.vue";

export default {
  name: "Checklist",
  components: {
    Navbar,
    Breadcrumb,
    SelectLanguage,
  },
  setup() {
    const store = useStore();

    // Reactive data
    const language = ref(38);
    const step = ref(0);
    const questions = ref([]);
    const settinganswer = ref(false);
    const currentoption = ref(0);
    const answers = ref([]);
    const result = ref(0);
    const texts = ref([]);
    const options = ref([]);
    const indicatortop = ref("200px");

    // Methods
    const sleep = (milliseconds) =>
      new Promise((resolve) => setTimeout(resolve, milliseconds));

    const gettexts = (lang) => {
      const textCollection = [];
      const filter = {
        language_id: {
          operator: "=",
          value: lang || 38,
        },
      };
      const payload = {
        table_name: "g_checklisttexts",
        filter,
      };
      store.dispatch("records_readall", payload).then((resp) => {
        const r = resp.data.result;
        for (let i = 0; i < r.length; i++) {
          textCollection[r[i].text_number] = r[i].text;
        }
        texts.value = textCollection;
        options.value = [];
        options.value.push(
          textCollection[12] ? textCollection[12] : "Not at all"
        );
        options.value.push(textCollection[13] ? textCollection[13] : "Partly");
        options.value.push(
          textCollection[14] ? textCollection[14] : "Completely"
        );
      });
    };

    const setlanguage = (value) => {
      language.value = parseInt(value, 10);
    };

    const startover = () => {
      const userlang = localStorage.getItem("GDQChecklistLanguage");
      if (userlang) {
        language.value = parseInt(userlang, 10);
      }
      step.value = 0;
      answers.value = [];
      gettexts(language.value);
      questions_get();
    };

    const questions_get = () => {
      store
        .dispatch("checklistquestions_fetch", {
          language_id: language.value || 38,
        })
        .then((resp) => {
          questions.value = resp.data;
        });
    };

    const nextstep = async (millisecs = 0) => {
      await sleep(millisecs);
      step.value++;
      result.value = 0;
      for (let i = 1; i < 7; i++) {
        result.value += answers.value[i] || 0;
      }
      indicatortop.value = (12 - (result.value - 6)) * (357 / 12);
    };

    const prevstep = () => {
      step.value = Math.max(0, step.value - 1);
    };

    const handleAnswer = async (question_number, answer) => {
      if (settinganswer.value) {
        return;
      }
      settinganswer.value = true;
      answers.value[question_number] = answer;
      currentoption.value = answer;
      await nextstep(300);
      settinganswer.value = false;
      currentoption.value = 0;
    };

    // Watchers
    watch(
      () => language.value,
      (newLanguage) => {
        gettexts(newLanguage);
        questions_get();
        localStorage.setItem("GDQChecklistLanguage", String(newLanguage));
      }
    );

    // Lifecycle hook
    onMounted(() => {
      const userlang = localStorage.getItem("GDQChecklistLanguage");
      if (userlang) {
        language.value = parseInt(userlang, 10);
      }
      gettexts(language.value);
      questions_get();
    });

    return {
      // Reactive data
      language,
      step,
      questions,
      settinganswer,
      currentoption,
      answers,
      result,
      texts,
      options,
      indicatortop,

      // Methods
      setlanguage,
      startover,
      questions_get,
      nextstep,
      prevstep,
      handleAnswer,
      gettexts,
    };
  },
};
</script>

<style scoped>
.survey-type-badge {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #007d8f;
}

.survey-icon {
  color: #ffffff !important;
  width: 34px;
  height: 34px;
}

.thermometer {
  width: 100px;
  height: 360px;
  background: rgb(255, 0, 0);
  background: linear-gradient(0deg, #e59ea1 0%, #fded97 50%, #8bcac1 100%);
}
.indicator {
  width: 100px;
  border-top: 2px solid #000;
  margin-left: -20px;
}
</style>
